<template>
  <div class="countdown-wrapper mb-3" v-if="show">
    <div class="lauching-title">{{ `WE'RE LAUNCHING SOON` }}</div>
    <div class="c-row">
      <div class="c-col">
        <div class="c-number">{{ $_.padStart(`${days || 0}`, 2, "0") }}</div>
        <div class="c-label">Days</div>
      </div>
      <div class="c-col">
        <div class="c-number c-colon">:</div>
        <div class="c-label"></div>
      </div>
      <div class="c-col">
        <div class="c-number">{{ $_.padStart(`${hours || 0}`, 2, "0") }}</div>
        <div class="c-label">Hours</div>
      </div>
      <div class="c-col">
        <div class="c-number c-colon">:</div>
        <div class="c-label"></div>
      </div>
      <div class="c-col">
        <div class="c-number">{{ $_.padStart(`${minutes || 0}`, 2, "0") }}</div>
        <div class="c-label">Minutes</div>
      </div>
      <div class="c-col">
        <div class="c-number c-colon">:</div>
        <div class="c-label"></div>
      </div>
      <div class="c-col">
        <div class="c-number">{{ $_.padStart(`${seconds || 0}`, 2, "0") }}</div>
        <div class="c-label">Seconds</div>
      </div>
    </div>

    <!-- {{ days }} {{ hours }}:{{ minutes }}:{{ seconds }} -->
  </div>
</template>
<script>
export default {
  name: "Countdown",
  props: ["time"],
  data: () => ({
    days: null,
    hours: null,
    minutes: null,
    seconds: null,
    show: false,
  }),
  methods: {
    startTimer: function () {
      const timeNow = new Date().getTime();
      const timeDiff = new Date(this.time).getTime() - timeNow;
      this.show = timeDiff > 0;
      const millisecondsInOneSecond = 1000;
      const millisecondsInOneMinute = millisecondsInOneSecond * 60;
      const millisecondsInOneHour = millisecondsInOneMinute * 60;
      const millisecondsInOneDay = millisecondsInOneHour * 24;
      const differenceInDays = timeDiff / millisecondsInOneDay;
      const remainderDifferenceInHours =
        (timeDiff % millisecondsInOneDay) / millisecondsInOneHour;
      const remainderDifferenceInMinutes =
        (timeDiff % millisecondsInOneHour) / millisecondsInOneMinute;
      const remainderDifferenceInSeconds =
        (timeDiff % millisecondsInOneMinute) / millisecondsInOneSecond;
      this.days = Math.floor(differenceInDays);
      this.hours = Math.floor(remainderDifferenceInHours);
      this.minutes = Math.floor(remainderDifferenceInMinutes);
      this.seconds = Math.floor(remainderDifferenceInSeconds);
    },
  },
  mounted() {
    setInterval(() => {
      this.startTimer();
    }, 1000);
  },
  watch: {
    show(newVal, oldVal) {
      if (newVal === true && oldVal === false) {
        this.$emit("onReload", true);
      } else {
        this.$emit("onReload", false);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.countdown-wrapper {
  display: flex;
  flex-direction: column;
  justify-items: center;
  align-items: center;
  align-self: center;
  .lauching-title {
    font-size: 25px;
    font-weight: bold;
    text-transform: uppercase;
  }
  .c-row {
    display: flex;
    flex-direction: row;
    .c-col {
      display: flex;
      flex-direction: column;
      justify-items: center;
      align-items: center;
      .c-number {
        font-weight: bold;
        font-size: 68px;
        color: #eb345f;
        padding: 0 2px;
        line-height: normal;
      }
      .c-label {
        color: #ffffff;
        text-transform: uppercase;
        font-size: 12px;
        font-weight: 500;
        line-height: normal;
      }
      .c-colon {
        color: #ffffff;
        line-height: normal;
        font-weight: 500;
      }
    }
  }
}
</style>
